import { AdditionalMessageUI } from "./AdditionalMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { removeIFCMessages } from "@/utils/product/interestFreeCredit/removeIFCMessages.ts";

export function AdditionalMessage({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) {
  const isNewTypographyEnabled = flags?.useNewTypography.value === true;
  const { variant } = useVariant(product);

  const { messaging = [] } = variant;

  const additionalMessages = removeIFCMessages(
    messaging.filter((message) => message.type === "additional"),
  ).map(({ title }) => title);

  return (
    <AdditionalMessageUI
      messages={additionalMessages}
      isNewTypographyEnabled={isNewTypographyEnabled}
    />
  );
}
